var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content hr-export" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { lazy: true, type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.tabHrRealGpReportIsShowed
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: "HR Real GP Report",
                      name: "hrRealGpReport"
                    }
                  },
                  [
                    _c("tab-hr-real-gp-report", {
                      ref: "hrRealGpReport",
                      attrs: {
                        "copy-month-list": _vm.copyMonthList,
                        "latest-monthly-date": _vm.latestMonthlyDate,
                        "is-show": _vm.hrRealGpReportIsShow,
                        "query-branch-list": _vm.queryBranchList,
                        "query-dept-id-list": _vm.queryDeptIdList
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }